
















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import InvoiceInfo from "@/consoleapi/api/invoice_info";

@Component
export default class BillingInfoConfirm extends Vue {
    @Prop() public name!: string;
    @Prop() public kana!: string;
    @Prop() public companyName!: string;
    @Prop() public email!: string;
    @Prop() public emailCc1!: string;
    @Prop() public emailCc2!: string;
    @Prop() public emailCc3!: string;
    // @Prop() public postCode!: string;
    @Prop() public postCodeFirst!: string;
    @Prop() public postCodeLatter!: string;
    @Prop() public address!: string;
    @Prop() public buildingName!: string;
    @Prop() public departmentName!: string;

    @Prop() bearerToken!: string;
    @Prop() accountId!: string;
    @Prop() userId!: string;

    goInputPage(){
        this.$store.dispatch('billingInfo/pushProgress', 'input');
    }

    doRegister(){
        const invoiceInfo = new InvoiceInfo();
        invoiceInfo.setBearerToken(this.bearerToken);
        invoiceInfo.create(this.accountId, this.userId, this.name, this.kana, this.email, this.emailCc1, this.emailCc2, this.emailCc3,
            this.postCodeFirst + this.postCodeLatter, this.address, this.buildingName, this.departmentName, this.companyName)
            .then(response => {
                //console.log(response.data);
                this.$store.dispatch('billingInfo/pushProgress', 'result');
            }).catch(error => {
                // console.log(error.response);
                const errors = error.response.data.errors;
                let data = '';
                for (const i in errors){
                    data += errors[i] + "\n";
                }
                alert(data);
        })
    }
}
